import { devtools } from 'zustand/middleware'
import { createStore } from 'zustand/vanilla'

import { isDebugEnabled } from '../utils/debug'

import type { AppState } from './types'
import { APP_STATUS, SUBMISSION_STATUS } from './types/enums'

export type AppStore = typeof appStore

export const INITIAL_STATE: AppState = {
  appStatus: APP_STATUS.IDLE,
  journeys: {},
  featureFlags: {},
  darkMode: false,
  blockValues: {},
  logicsEngine: {
    history: [],
    locked: false
  },
  navigatedPath: [],
  submissionState: {
    status: SUBMISSION_STATUS.IDLE
  }
}

export const appStore = createStore<AppState>()(
  devtools((_set, _get) => INITIAL_STATE, {
    name: `@epilot/journey-app (${window.location.hostname})`,
    enabled: isDebugEnabled(),
    /**
     * Set the below to true to enable tracing, in case helpful for debugging.
     *
     * WARNING: This can really hurt performance, therefore shouldn't be left enabled
     * in ANY environment.
     *
     * @see {@link https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/Features/Trace.md}
     */
    trace: false
  })
)
